export const monthDayToString = (dayOfMonth: number) => {
  return (
    (dayOfMonth === 1 && "1st") ||
    (dayOfMonth === 2 && "2nd") ||
    `${dayOfMonth}th`
  );
};
